@if (!isInFolder()) {
    <app-realized-work-page-header [form]="form"></app-realized-work-page-header>
}

<app-table
    tableKey="workSanctions"
    [gridData]="$any(store.data.getWorks())"
    [transformItem]="workHideDelete()"
    [columns]="columns()"
    translatePrefix="workData.sanction."
    [showSearch]="true"
    [showColumnVisiblity]="true"
    [showExport]="true"
    (deleteCallbackWithEvent)="delete($event)"
    (detailCallback)="detail($event)"
    [additionalFilter]="additionalFilter()"
    [refreshCallback]="store.api.getWorks"
    [refreshCallbackFragment]="getWorksFrag"
    [defaultSorters]="[{ column: 'dateFrom', direction: 'DESC' }]"
>
    <ng-template pTemplate="print" let-item="item">
        <app-button
            icon="pi-print"
            severity="primary"
            [text]="true"
            styleClass="tableIcon"
            (clickEvent)="print(item)"
        ></app-button>
    </ng-template>

    <ng-template pTemplate="footer" let-items="items" let-columns="columns">
        <tr>
            <td>{{ 'summary' | translate }}:</td>
            <td></td>
            @for (col of columns; track col.name) {
                <td>
                    @if (col.name === 'dateFrom') {
                        <span>{{ 'database.workVisits.uniqueDates' | translate }}{{ items | workUniqueDays }}</span>
                    } @else if (col.name === 'users') {
                        <span>{{ 'database.workVisits.uniqueWorkers' | translate }}{{ items | workUniques: 'users' }}</span>
                    } @else if (col.name === 'folder') {
                        <span>{{ 'database.workVisits.uniqueFolders' | translate }}{{ items | workUniques: 'folderId' }}</span>
                    }
                </td>
            }
            <td></td>
        </tr>
    </ng-template>
</app-table>
